<footer class="site-footer">
  <div class="site-footer__main">
    <div class="site-footer__brand">
      <img
        class="site-footer__logo"
        ngSrc="assets/img/azone-construction-logo.svg"
        width="544"
        height="187"
        priority
        alt="Azone Construction"
        routerLink="/"
      />

      <div class="site-footer__socials" aria-label="Social media">
        <a href="https://www.instagram.com/azone_construction" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
          <i class="fab fa-instagram"></i>
        </a>
        <a target="_blank" rel="noopener noreferrer" aria-label="Facebook">
          <i class="fab fa-facebook"></i>
        </a>
        <a target="_blank" rel="noopener noreferrer" aria-label="Twitter">
          <i class="fab fa-twitter"></i>
        </a>
        <a target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
          <i class="fab fa-linkedin"></i>
        </a>
      </div>
    </div>

    <nav class="site-footer__nav" aria-label="Footer navigation">
      <div class="site-footer__column site-footer__column--expertise">
        <h2 routerLink="/expertises">
          {{ 'expertise.expertise' | translate | async }}
        </h2>

        <div class="site-footer__links site-footer__links--expertise">
          @for (expertise of (expertiseList$ | async) ?? []; track expertise.id) {
            <a
              class="site-footer__link"
              [routerLink]="'/expertises/expertise/' + expertise.id + '/' + expertise.name"
            >
              {{ expertise.name | truncate: 20 }}
            </a>
          }
        </div>
      </div>

      <div class="site-footer__column">
        <h2 routerLink="/contact">
          {{ 'locations.locations' | translate | async }}
        </h2>

        <div class="site-footer__links">
          @for (contact of (contactsList$ | async) ?? []; track contact) {
            <a class="site-footer__link" routerLink="/contact">
              {{ contact }}
            </a>
          }
        </div>
      </div>

      <div class="site-footer__column">
        <h2>Legal.</h2>

        <div class="site-footer__links">
          @for (legal of legalList; track $index) {
            <a class="site-footer__link" [routerLink]="legal.link">
              {{ legal.label }}
            </a>
          }
        </div>
      </div>
    </nav>
  </div>

  <div class="site-footer__bottom">
    <p>© {{ date }} Azone Construction - All rights reserved</p>
  </div>
</footer>
